<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->

<div class="container" fxLayout="column">
  <oneapp-header
    *ngIf="task"
    [title]="task.name"
    (buttonClick)="onActionButtonClick($event)"
    [customButtonConfig]="customButtonConfig"
    [actionsMenuConfig]="actionsMenuConfig"
    [dismissButtonConfig]="showDismissButton ? dismissButtonConfig : undefined"
  ></oneapp-header>

  <!-- loading spinner -->
  <div *ngIf="loadingTask" fxFill fxLayoutAlign="center center">
    <fa-icon
      class="icon loading_spinner"
      [icon]="faSpinnerThird"
      aria-label="user settings button"
    ></fa-icon>
  </div>

  <div class="detail_data_container" *ngIf="!loadingTask && task" fxLayout="column">
    <div class="tabs_container">
      <div class="status-chip-container" *ngIf="task">
        <mat-chip-set
          class="status-chip-set"
          [ngClass]="{
            'open-chip': task.status === TaskStatus.NEW,
            'in-progress-chip': task.status === TaskStatus.IN_PROGRESS,
            'closed-unfinished-chip': task.status === TaskStatus.CLOSED && isClosedBeforeFinished(task),
            'finished-chip': task.status === TaskStatus.CLOSED && !isClosedBeforeFinished(task)
          }"
        >
          <mat-chip *ngIf="task.status === TaskStatus.NEW"
            ><span i18n="Open task chip@@openTaskChip">Open</span> &nbsp;
            <fa-icon class="icon" [icon]="faStar"></fa-icon
          ></mat-chip>
          <mat-chip *ngIf="task.status === TaskStatus.IN_PROGRESS"
            ><span i18n="In progress task chip@@inProgressTaskChip">In progress</span> &nbsp;
            <fa-icon class="icon" [icon]="faArrowRight"></fa-icon
          ></mat-chip>
          <mat-chip *ngIf="task.status === TaskStatus.CLOSED && !isClosedBeforeFinished(task)"
            ><span i18n="Finished task chip@@finishedTaskChip">Finished</span> &nbsp;
            <fa-icon class="icon" [icon]="faCheck"></fa-icon
          ></mat-chip>
          <mat-chip *ngIf="task.status === TaskStatus.CLOSED && isClosedBeforeFinished(task)"
            ><span i18n="Closed task chip@@closedTaskChip">Closed (unfinished)</span> &nbsp;
            <fa-icon class="icon" [icon]="faCheck"></fa-icon
          ></mat-chip>
        </mat-chip-set>
      </div>

      <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        [(selectedIndex)]="selectedTabIndex"
      >
        <mat-tab>
          <ng-template mat-tab-label>
            <span i18n="header overview@@overview">Overview</span>
          </ng-template>

          <div class="detail-output-data" fxLayout="column">
            <app-task-general-data [task]="task" [enableLink]="enableLink"></app-task-general-data>
          </div>
        </mat-tab>

        <!-- protocol -->
        <mat-tab [disabled]="!hasProtocolTabContent()">
          <ng-template mat-tab-label>
            <span
              class="activateDisabledTooltip"
              [matTooltipDisabled]="hasProtocolTabContent()"
              matTooltip="No data available"
              i18n-matTooltip="@@noDataAvailable"
              i18n="header protocol@@protocol"
              >Protocol</span
            >
          </ng-template>
          <div class="detail-output-data" fxLayout="column" *ngIf="hasProtocolTabContent()">
            <app-map
              class="map"
              *ngIf="hasMapContent()"
              [location]="task.tracing"
              [taskStatus]="task.status"
              [taskStatesLocation]="taskStatesGeotags"
            ></app-map>

            <div fxLayout="column" fxFill *ngIf="task.record">
              <app-record
                [recordData]="task.record"
                [taskEndTimeStamp]="getTaskEndTimeStamp()"
              ></app-record>
            </div>
          </div>
        </mat-tab>

        <!-- output -->
        <mat-tab [disabled]="task.status === TaskStatus.NEW || !task.output">
          <ng-template mat-tab-label>
            <span
              class="activateDisabledTooltip"
              [matTooltipDisabled]="!!task.output"
              matTooltip="No data available"
              i18n-matTooltip="@@noDataAvailable"
              i18n="header output@@output"
              >Output</span
            >
          </ng-template>
          <div class="detail-output-data" fxLayout="column" *ngIf="task.output">
            <div fxLayout="column" fxFill>
              <app-task-datum-viewer [taskData]="[task.output]"></app-task-datum-viewer>
            </div>
          </div>
        </mat-tab>

        <!-- attachments -->
        <mat-tab *ngIf="task.meta_data?.attachments?.length" [disabled]="!task.meta_data?.attachments?.length">
          <ng-template mat-tab-label>
            <span
              class="activateDisabledTooltip"
              [matTooltipDisabled]="!!task.meta_data?.attachments?.length"
              matTooltip="No attachments available"
              i18n-matTooltip="@@noAttachmentsAvailable"
              i18n="header attachments@@attachments"
              >Attachments</span
            >
          </ng-template>
          <div class="detail-output-data" fxLayout="column">
            <app-attachments-display
              [attachments]="task.meta_data?.attachments"
            ></app-attachments-display>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
